import { createUserOpt } from "@sourcewhale/shared/src/assets/js/src/general/elements/tables.js";
import { teamHasDialler } from "@sourcewhale/shared/src/assets/js/src/general/licenses.js";
import {
  addSearchToggleClickEvent,
  addSpinner,
  backdropAlert,
  capitalize,
  chartColors,
  cookieValue,
  EU_DIALLER_COUNTRIES,
  getEndDate,
  getStartDate,
  getUser,
  handleToggleFilter,
  localDateTimeString,
  nameAndPhoto,
  removeSpinner,
  showToast,
  urlParams,
  userDiallerCountries,
  uuidV4,
  wrappedGet,
  wrappedPost,
  wrapTooltip,
  yesNoConfirm,
} from "@sourcewhale/shared/src/assets/js/src/general/utils";
import { addWebsocketListener } from "@sourcewhale/shared/src/assets/js/src/general/websocket";
import { bindLicenseComponents } from "../../../../svelte/src/bindings/admin.js";
import { showAddUsersModal } from "../../../../svelte/src/pages/Admin/AddUserModal/stores.js";
import {
  assignLicenseModalProps,
  SIGN_IN_LICENSES,
} from "../../../../svelte/src/pages/Admin/AssignLicenseModal/stores.js";
const tab = urlParams.get("tab");

let USER_DICT = {};
let TEAM_GROUP_DICT = {};
const LIMITS = {};

const DNS_HOSTS = {
  aws: {
    name: "AWS",
    url: "https://aws.amazon.com/route53/",
    guide:
      "https://help.sourcewhale.app/en/articles/11896329-how-to-set-up-custom-domain-tracking-for-aws-route-53-domains",
  },
  azure: {
    name: "Azure",
    url: "https://learn.microsoft.com/en-us/azure/dns/dns-overview",
    guide:
      "https://help.sourcewhale.app/en/articles/11896362-how-to-set-up-custom-domain-tracking-for-azure-domains",
  },
  cloudflare: {
    name: "Cloudflare",
    url: "https://www.cloudflare.com/en-gb/application-services/products/dns/",
    guide:
      "https://help.sourcewhale.app/en/articles/11896382-how-to-set-up-custom-domain-tracking-for-cloudflare-domains",
  },
  csc: {
    name: "CSC",
    url: "https://www.cscdbs.com/en/domain-security/dns-services/",
    guide:
      "https://help.sourcewhale.app/en/articles/11896398-how-to-set-up-custom-domain-tracking-for-csc-domains",
  },
  gcp: {
    name: "Google Cloud",
    url: "https://cloud.google.com/dns",
    guide:
      "https://help.sourcewhale.app/en/articles/11896405-how-to-set-up-custom-domain-tracking-for-google-cloud-platform-domains",
  },
  godaddy: {
    name: "GoDaddy",
    url: "https://www.godaddy.com/",
    guide:
      "https://help.sourcewhale.app/en/articles/11896202-how-to-set-up-custom-domain-tracking-for-godaddy-domains",
  },
  namecheap: {
    name: "Namecheap",
    url: "https://www.namecheap.com/",
    guide:
      "https://help.sourcewhale.app/en/articles/11896412-how-to-set-up-custom-domain-tracking-for-namecheap-domains",
  },
};

const COMPLIANCE_COUNTRIES = [
  "AU",
  "AE",
  "CA",
  "DK",
  "GB",
  "IE",
  "US",
  ...EU_DIALLER_COUNTRIES,
];
const DIALLER_COUNTRIES = [
  "au",
  ...EU_DIALLER_COUNTRIES.map((country) => country.toLowerCase()),
];
let showCompliances = {};
const SUPPORTING_DOCS = ["Excerpt", "ProofId", "ProofAuthorization"];
let supportingDocs = {};
let isAddSeatsBtnClicked = false;

const ADDRESS_FIELDS = {
  inputFields: ["streetAddress", "city", "postcode"],
  selectFields: ["state"],
};
const COMPLIANCE_FIELDS = {
  at: {
    inputFields: ["contactFirstName", "contactLastName"],
    selectFields: ["proofIdType"],
    includeExcerpt: true,
    includeProofId: true,
  },
  au: {
    inputFields: ["businessNumber"],
    includeExcerpt: true,
  },
  cz: {
    inputFields: ["businessNumber", "contactFirstName", "contactLastName"],
    selectFields: ["proofIdType", "proofAuthorizationType"],
    includeExcerpt: true,
    includeProofId: true,
    includeProofAuthorization: true,
  },
  de: {
    inputFields: ["vatNumber", "registrationNumber"],
    includeExcerpt: true,
  },
  fi: {},
  kyc: {
    inputFields: ["registrationNumber"],
    selectFields: ["registrationAuthority"],
    includeExcerpt: true,
  },
  nl: {
    inputFields: ["vatNumber"],
    includeExcerpt: true,
  },
  pt: {
    inputFields: ["taxIdNumber"],
    includeExcerpt: true,
  },
  ro: {
    inputFields: [
      "contactFirstName",
      "contactLastName",
      "birthDate",
      "documentNumber",
      "expiryDate",
      "tradeRegistryNumber",
    ],
    selectFields: ["proofIdType", "proofAuthorizationType"],
    includeExcerpt: true,
    includeProofId: true,
    includeProofAuthorization: true,
  },
};

const ccComplianceFields = (cc, individual = false) => {
  const obj = {};
  const key = individual ? cc : `compliance${capitalize(cc)}`;
  const complianceFields = COMPLIANCE_FIELDS[cc] || {};

  const { inputFields = [], selectFields = [] } = complianceFields;

  [...inputFields, ...ADDRESS_FIELDS.inputFields].forEach((field) => {
    const selector = $(`#${key}${capitalize(field)}Input`);
    if (!selector) return;
    obj[field] = selector.val();
  });

  [...selectFields, ...ADDRESS_FIELDS.selectFields].forEach((field) => {
    const selector = $(`#${key}${capitalize(field)}Select`);
    if (!selector) return;
    obj[field] = selector.selectpicker("val");
  });

  SUPPORTING_DOCS.forEach((doc) => {
    if (complianceFields[`include${doc}`]) {
      obj[doc.toLowerCase()] = supportingDocs[`${cc}${doc}`];
    }
  });

  return obj;
};

const refreshLimitInput = () => {
  const input = $("#sendLimitInput");
  const val = input.val();

  input.removeClass("warning-range danger-range");
  $("#sendLimitOutput").show().val(val);

  let tooltip;
  if (val <= 200) tooltip = "This is a generally safe number";
  else if (val <= 500) {
    tooltip = "This level risks going into spam";
    input.addClass("warning-range");
  } else {
    tooltip = "Only choose this level if you have high reply rates";
    input.addClass("danger-range");
  }
  input.tooltip("dispose").tooltip({
    title: tooltip,
    placement: "bottom",
    trigger: "manual",
  });
};

const refreshGapInput = () => {
  const input = $("#minGapInput");
  const val = input.val();

  input.removeClass("warning-range danger-range");
  $("#minGapOutput").show().val(`${val}s`);

  let tooltip;
  if (val >= 60) tooltip = "This is a generally safe number";
  else if (val >= 30) {
    tooltip = "This level risks going into spam";
    input.addClass("warning-range");
  } else {
    tooltip = "Only choose this level if you have high reply rates";
    input.addClass("danger-range");
  }
  input.tooltip("dispose").tooltip({
    title: tooltip,
    placement: "bottom",
    trigger: "manual",
  });
};

const fillTable = (selector, data) => {
  const table = $(`#${selector}`).DataTable();
  table.clear();
  table.rows.add(data);
  table.columns.adjust().draw(false);
};

const fillUserSelector = (
  selector,
  users,
  ignoreNonUsers = true,
  newUserOption = false,
) => {
  const select = $(selector);
  select.find("option").remove();

  if (newUserOption) {
    select.append(
      $("<option>", {
        value: "newUser",
        "data-content": `<i class="fas fa-user-plus mr-2"></i>New User`,
      }),
    );
  }

  users
    .sort((a, b) => a.email.toLowerCase().localeCompare(b.email.toLowerCase()))
    .forEach((user) => {
      if (ignoreNonUsers && !["user", "superUser"].includes(user.kind)) return;
      select.append(
        $("<option>", {
          value: user.userId,
          "data-content": `<i class="fas fa-user mr-2"></i>${user.email}`,
        }),
      );
    });
  select.selectpicker("refresh");
};

const fillSeatsBars = () => {
  const nUsers = {
    user: 0,
    superUser: 0,
    alias: 0,
    viewer: 0,
  };

  Object.values(USER_DICT).forEach((u) => {
    nUsers[u.kind] += 1;
  });

  const fillSeatsBar = (selector, currentSeats, totalSeats) => {
    if (currentSeats === totalSeats)
      $(`${selector} .progress-bar`).css("background-color", "#ff0000");
    else $(`${selector} .progress-bar`).css("background-color", "#1ca2d8");
    $(`${selector} .nSeatsUsed`).text(`${currentSeats}/${totalSeats}`);
    $(`${selector} .progress-bar`).css(
      "width",
      `${Math.round((currentSeats / totalSeats) * 100)}%`,
    );
  };

  fillSeatsBar("#userSeats", nUsers.user + nUsers.superUser, LIMITS.nSeats);
  fillSeatsBar("#aliasSeats", nUsers.alias, LIMITS.nAliasSeats);
  fillSeatsBar("#viewerSeats", nUsers.viewer, LIMITS.nViewerSeats);
};

const fillSamlSettings = (data) => {
  if (!data) return;
  $(`#${data.provider}URL`).val(data.SSOurl);
  $(`#${data.provider}EntityID`).val(data.entityId);
};

const displayCurrentCustomDomain = (domain) => {
  $("#currentCustomDomainDiv").show();
  $("#currentCustomDomainInput").val(domain.domain);

  $("#caaRecordNotice").toggle(domain.needsCAARecords);

  $("#domainRecordsInstructions").toggle(!domain.isLive);
  $("#domainRecordsHostProvider").empty().hide();
  if (!domain.isLive && DNS_HOSTS[domain.dnsHost]) {
    const { name, url, guide } = DNS_HOSTS[domain.dnsHost];
    const html = `
      <p>We've detected that your domain is hosted with <a class="text-primary" href="${url}" target="_blank">${name}</a>. Follow the steps Below to complete your setup:</p>
      <p>
        <li class="mt-1">Log in to your <a class="text-primary" href="${url}" target="_blank">${name}</a> account</li>
        <li class="mt-1">Add the CNAME records listed below</li>
      </p>
      <p>View our step-by-step <a class="text-primary" href="${guide}" target="_blank">setup guide</a> for more information.</p>
      `;
    $("#domainRecordsHostProvider").html(html).show();
  }

  domain.caaRecordName = "@";
  domain.caaRecordValue = '0 issue "amazon.com"';

  [
    "redirectRecordName",
    "redirectRecordValue",
    "validationRecordName",
    "validationRecordValue",
    "caaRecordName",
    "caaRecordValue",
  ].forEach((key) => {
    $(`#${key}`).text(domain[key]);

    $(`#${key}CopyBtn`).click(() => {
      navigator.clipboard.writeText(domain[key]).then(() => {
        showToast({
          id: "copiedToClipboardToast",
          title: "Copied to clipboard",
        });
      });
    });
  });

  const foundIcon = `<i class="fas fa-check text-primary record-info-icon" data-title="This record has been found!"></i>`;
  const notFoundIcon = `<i class="fas fa-info-circle record-info-icon" data-title="This record hasn't been found. If you recently added it, please click the 'Check Records' button below."></i>`;

  $(".record-info-icon").tooltip("dispose");

  $("#caaRecordFound").html(domain.hasCAARecords ? foundIcon : notFoundIcon);
  $("#validationRecordFound").html(
    domain.isValidated ? foundIcon : notFoundIcon,
  );
  $("#redirectRecordFound").html(
    domain.isRedirected ? foundIcon : notFoundIcon,
  );

  $(".record-info-icon")
    .tooltip("dispose")
    .tooltip({ html: true, target: "hover" });
};

const displayCustomDomainSettings = (domain) => {
  $('#customDomainCard [data-toggle="tooltip"]').tooltip("dispose");

  $("#currentCustomDomainDiv, #newCustomDomainDiv").hide();

  $("#customDomainInfoIcon").toggle(!(domain && domain.isLive));
  $("#customDomainIsLiveIcon").toggle(!!(domain && domain.isLive)); // domain can be undefined

  $("#customDomainInput").prop("disabled", true);

  if (domain) {
    displayCurrentCustomDomain(domain);
  } else {
    $("#customDomainInput").prop("disabled", false);
    $("#newCustomDomainDiv").show();
  }

  $('#customDomainCard [data-toggle="tooltip"]')
    .tooltip("dispose")
    .tooltip({ html: true, target: "hover" });
};

const checkCustomDomain = () => {
  wrappedGet({
    url: "/api/admin/check_custom_domain",
    success: (domain) => {
      displayCustomDomainSettings(domain);
    },
    spinner: "#checkRecordsBtn",
  });
};

const modifyTeam = ({ key, val }) => {
  wrappedPost({
    url: "/api/admin/modify",
    data: JSON.stringify({ kind: "team", data: { [key]: val } }),
    success: () => {
      showToast({ title: "Saved", type: "success" });
    },
  });
};

const fillTeamGroupSelector = (
  selector,
  teamGroupArray,
  listUsers = true,
  listTeams = false,
) => {
  selector.find("option").remove();
  if (listUsers) {
    const sortedUsers = Object.values(USER_DICT).sort((a, b) =>
      a.name.localeCompare(b.name),
    );
    sortedUsers.forEach((user) => {
      const multi = sortedUsers.filter((u) => u.name === user.name).length > 1;
      const opt = createUserOpt(user, user.name, multi);
      selector.append($("<option>", opt));
    });
  }

  if (listTeams) {
    Object.entries(TEAM_GROUP_DICT).forEach(([groupId, val]) => {
      const opts = { value: groupId, text: val.groupName };
      selector.append($("<option>", opts));
    });
  }

  selector.selectpicker("refresh");
  const userIds = teamGroupArray.map(({ userId }) => userId);
  selector.selectpicker("val", userIds);
};

const populateTeamGroups = () => {
  $("#teamGroupsTable tbody").empty();
  $("#teamGroupsTable").hide();
  $("#addUserTeamGroupsDiv").hide();

  if (Object.keys(TEAM_GROUP_DICT).length === 0) return;

  Object.entries(TEAM_GROUP_DICT).forEach(([groupId, val]) => {
    const deleteBtn = wrapTooltip(
      ` <a data-id=${groupId} data-name="${val.groupName}" id="remove-team-group" class="remove-team-group-btn btn btn-light">
            <i data-id=${groupId} data-name="${val.groupName}" class="fa-regular fa-times text-danger"></i>
          </a>`,
      "Delete Group",
    );
    $("#teamGroupsTable tbody").append(/* html */ `
        <tr class="team-group" id="${groupId}">
          <td class="groupName" style="padding: 0.75rem;">
            <input data-id="${groupId}" id="group-name-input" type="text" class="form-control" value="${val.groupName}" />
          </td>
          <td class="teamGroupUsers" style="padding: 0.75rem;">
            <div class="input-group d-print-none round-left round-right">
              <select data-id="${groupId}" id="${groupId}-users" class="selectpicker teamGroup-user-selector" multiple data-actions-box="true" data-title="Choose..." data-selected-text-format="static" data-size="10" data-live-search="true"></select>
            </div>
          </td>
          <td class="buttons" style="padding: 0.75rem;">${deleteBtn}</td>
        </tr>
      `);

    fillTeamGroupSelector($(`#${groupId}-users`), val.users);
  });
  $("#teamGroupsTable").show();
  fillTeamGroupSelector($("#addUserTeamGroupsSelect"), [], false, true);
  $("#addUserTeamGroupsDiv").show();
};

const handleRestrictedAccountOptions = (res) => {
  if (res.isTest || res.isExtensionOnly) {
    const HIDE_ADMIN_OPTIONS = [
      "generalSettingsCard",
      "notInterestedReasonsCard",
      "customDomainCard",
    ];
    if (res.isExtensionOnly) {
      HIDE_ADMIN_OPTIONS.push(
        "v-pills-users-tab",
        "v-pills-users",
        "domainSendLimitCard",
      );
    }
    HIDE_ADMIN_OPTIONS.forEach((x) => {
      $(`#${x}`).hide();
    });
  }

  $("#admin-tabs-div").removeClass("skeleton-loading");
  $("#v-pills-tabContent").removeClass("skeleton-loading");
};

const addTeamGroups = (users, teamGroups) => {
  users.forEach((user) => {
    const teamGroupKeys = Object.keys(teamGroups).filter((key) =>
      teamGroups[key].users.some((teamUser) => teamUser.userId === user.userId),
    );
    if (teamGroupKeys.length > 0) {
      user.teamGroup = teamGroupKeys
        .map((key) => teamGroups[key].groupName)
        .join(", ");
      user.teamGroupIds = teamGroupKeys.map((key) => key);
    } else user.teamGroupIds = ["_none"];
  });
};

const updateTeamGroupTagSelector = (teamGroupDict, selectedGroupIds = []) => {
  const $selectPicker = $("#teamGroupSelector");
  $selectPicker.empty();

  $.each(
    { _none: { groupName: "No Group" }, ...teamGroupDict },
    (key, value) => {
      const teamGroup = {
        value: key,
        text: value.groupName,
        selected: selectedGroupIds.includes(key),
      };
      $selectPicker.append($("<option>", teamGroup));
    },
  );

  $selectPicker.selectpicker("refresh");
};

const refreshTables = (selectedGroupIds = []) => {
  wrappedGet({
    url: "/api/admin/get_team",
    data: { includeViewers: true },
    success: (res) => {
      res.users.sort((a, b) => a.firstName.localeCompare(b.firstName));

      USER_DICT = res.users.reduce((ret, user) => {
        ret[user.userId] = user;
        return ret;
      }, {});

      if (res.apiKey) {
        $("#deleteAPIKeyBtn").show();
        $("#apiKey").val(`Your API key ends in ${res.apiKey}`);
      }

      if (res.restrictDomains)
        $("#restrictDomainsInput").tokenfield("setTokens", res.restrictDomains);

      handleRestrictedAccountOptions(res);

      ["nSeats", "nAliasSeats", "nViewerSeats"].forEach((x) => {
        LIMITS[x] = res[x];
      });

      TEAM_GROUP_DICT = res.teamGroups;
      addTeamGroups(res.users, res.teamGroups);
      updateTeamGroupTagSelector(res.teamGroups, selectedGroupIds);

      const handleFilterToggle = () => {
        handleToggleFilter({
          items: res.users,
          ids: selectedGroupIds,
          toggleSelector: "#teamGroupSearchToggle",
          tableId: "usersTable",
          fillTable,
          property: "teamGroupIds",
        });

        // Table may get stuck on a page that no longer exists after filtering - reset to first page
        $("#usersTable").DataTable().page(0).draw(false);
      };

      $("#teamGroupSelector").on("change", (e) => {
        selectedGroupIds = $(e.currentTarget).val();
        handleFilterToggle();
      });

      addSearchToggleClickEvent({
        callback: () => handleFilterToggle(),
      });

      handleFilterToggle();

      fillUserSelector("#addUserAliasUserSelect", res.users);
      fillUserSelector("#modifyUserAliasUserSelect", res.users);
      fillUserSelector("#moveUserDataFromSelect", res.users, false);
      fillUserSelector("#moveUserDataToSelect", res.users, false, true);
      populateTeamGroups();

      fillSeatsBars();

      fillSamlSettings(res?.saml);

      $("#userInvitationsCard").toggle(!!res.invites.length);
      fillTable("userInvitesTable", res.invites);

      if (res.isTest || res.isExtensionOnly) {
        $("#v-pills-settings-tab").click();
        return;
      }

      $(".team-flags-item").remove();
      Object.entries(res.TEAM_FLAGS).forEach(([key, val]) => {
        if (key === "restrictActivityFeed") {
          const isRestrictActivityFeed = res[key];
          $("#activityFeedDropdown")
            .val(
              isRestrictActivityFeed
                ? "restrictActivityFeed"
                : "restrictSpecificDomains",
            )
            .trigger("change");
          if (res.restrictDomains && res.restrictDomains.length > 0) {
            $("#restrictDomainsInput").tokenfield(
              "setTokens",
              res.restrictDomains,
            );
          } else if (!isRestrictActivityFeed)
            $("#activityFeedDropdown").val("restrictNone").trigger("change");
          return;
        }

        $("#teamFlagsArea").append(/* html */ `
            <div class="team-flags-item custom-control custom-switch d-flex align-items-center mb-2">
              <input class="custom-control-input" type="checkbox" id="${key}">
              <label class="custom-control-label" for="${key}">
                ${val.title}
                <br>
                <span style="font-size: 75%; opacity: 0.75">${val.info}</span>
              </label>
            </div>
            `);

        if (key === "allowOpenTracking") {
          const toggle = $("#allowOpenTracking");
          toggle.prop("checked", res[key] !== false);
          toggle.change(() => {
            if (toggle.prop("checked")) {
              modifyTeam({ key, val: true });
            } else {
              yesNoConfirm(
                "<b>Are you sure you want to continue?</b><br><br>This action will disable open tracking for all live and scheduled campaigns across the team.",
                () => modifyTeam({ key, val: false }),
                () => toggle.prop("checked", true),
                "Confirm & Disable",
                "Cancel",
              ).on("shown.bs.modal", () => {
                $(".btn-primary").trigger("blur");
              });
            }
          });
        } else {
          $(`#${key}`).prop("checked", res[key]);
          $(`#${key}`).change((e) => {
            modifyTeam({ key, val: e.target.checked });
          });
        }
      });

      if (res.automateReplyTags) {
        $("#notInterestedReasonsCard").show();
      }

      const isDomainSendLimit =
        !!res.domainSendLimit && Object.keys(res.domainSendLimit).length > 0;

      $("#domainSendLimit").prop("checked", isDomainSendLimit);
      $("#domainSendLimitForm").toggle(isDomainSendLimit);

      const isCS = res.kind !== "bdOnly";
      const isBD = res.kind !== "inHouse";

      $("#csDomainSendLimit").toggle(isCS);
      $("#bdDomainSendLimit").toggle(isBD);

      $("#domainSendLimitForm .form-row").toggleClass("mt-3", isBD && isCS);

      $("#csDomainSendLimit label").toggle(isBD && isCS);
      $("#bdDomainSendLimit label").toggle(isBD && isCS);

      if (isDomainSendLimit) {
        if (res.domainSendLimit.candidateSourcing) {
          $("#csDomainSendLimitInput").val(
            res.domainSendLimit.candidateSourcing,
          );
          $("#csDomainSendLimitOutput").val(
            res.domainSendLimit.candidateSourcing,
          );
        }
        if (res.domainSendLimit.businessDevelopment) {
          $("#bdDomainSendLimitInput").val(
            res.domainSendLimit.businessDevelopment,
          );
          $("#bdDomainSendLimitOutput").val(
            res.domainSendLimit.businessDevelopment,
          );
        }
        if (res.domainSendLimit.excluded) {
          $("#domainExclusionTextArea").val(
            res.domainSendLimit.excluded.join(", "),
          );
        }
      }

      $("#fontFamily").selectpicker("val", res.fontFamily);
      $("#defaultFontSize").selectpicker("val", res.defaultFontSize);
      $(".selectpicker").selectpicker("refresh");

      displayCustomDomainSettings(res.domain);

      const hasDomain = !!(res.domain && res.domain.isLive);

      const statusMap = {
        sms: res.twilioSmsStatus,
        stirShaken: res.twilioStirShakenStatus,
        kyc: res.twilioRegulationBundleStatus?.GB,
      };

      const hasDialler = teamHasDialler(false);

      showCompliances = {
        sms:
          !!res.includeSms &&
          res.smsRegions?.includes("US") &&
          (hasDomain || ["approved", "pending"].includes(statusMap.sms)),
        stirShaken: true, // always show stir shaken
        kyc:
          (hasDialler && userDiallerCountries().includes("GB")) ||
          res.smsRegions?.includes("GB"), // only show KYC for GB dialer teams, or UK SMS teams
      };

      DIALLER_COUNTRIES.forEach((cc) => {
        statusMap[cc] = res.twilioRegulationBundleStatus?.[cc.toUpperCase()];
        showCompliances[cc] =
          hasDialler && userDiallerCountries().includes(cc.toUpperCase());
      });

      const complianceStatuses = Object.fromEntries(
        Object.entries(statusMap).filter((x) => showCompliances[x[0]]),
      );

      const showCompliance = !!Object.keys(complianceStatuses).length;

      ["complianceAdditionalCountries", "additionalCountriesRegister"].forEach(
        (key) => {
          const addCountriesSelector = $(`#${key}Select`);
          DIALLER_COUNTRIES.forEach((cc) => {
            addCountriesSelector
              .find(`option[value="${cc.toUpperCase()}"]`)
              .prop("disabled", !showCompliances[cc]);
          });
          addCountriesSelector.selectpicker("refresh");

          const showAddCountries = DIALLER_COUNTRIES.some(
            (cc) => showCompliances[cc],
          );
          addCountriesSelector.toggleClass("d-none", !showAddCountries);
          $(`#${key}Div`).toggle(showAddCountries);
        },
      );

      if (hasDialler) {
        $("#diallerFlagsDiv").empty();
        $("#diallerFlagsDiv").show();

        const toggleDiallerRecordingText = (text, isOn) => {
          const ON = "is on by default";
          const OFF = "is off by default";
          return text.replace(isOn ? OFF : ON, isOn ? ON : OFF);
        };

        const toggleRecordingLock = (key, lockKey, isLocked) => {
          isLocked = ![null, undefined].includes(isLocked) && isLocked;
          const removeClass = isLocked ? "fa-lock-open" : "fa-lock";
          const addClass = isLocked ? "fa-lock" : "fa-lock-open";
          $(`#${lockKey}`).removeClass(removeClass).addClass(addClass);
          $(`#${lockKey}`).attr("data-value", isLocked ? "locked" : "unlocked");
          $(`#${key}Container`).toggleClass("disabled", isLocked);
          $(`#${key}`).prop("disabled", isLocked);
        };

        Object.entries(res.TEAM_DIALLER_FLAGS).forEach(([key, val]) => {
          let teamVal = res[key];
          let { info } = val;
          const { title, lockable, lockKey, lockedMessage } = val;

          if (key === "diallerDefaultRecordingOn") {
            if (teamVal === undefined || teamVal === null) teamVal = true;
            info = toggleDiallerRecordingText(info, teamVal);
          }

          let lockHtml = "";
          if (lockable) {
            const locked = res[lockKey] ? "locked" : "unlocked";
            const icon = locked === "locked" ? "fa-lock" : "fa-lock-open";
            const html = `<i data-value="${locked}" id="${lockKey}" class="ml-2 fa-lg text-gray-500 fa-solid ${icon}"></i>`;
            lockHtml = wrapTooltip(html, lockedMessage, "top");
          }

          $("#diallerFlagsDiv").append(/* html */ `
              <div class="d-flex">
                <div id="${key}Container" class="dialler-flag-container custom-control custom-switch d-flex align-items-center mb-2">
                  <input class="d-none custom-control-input" type="checkbox" id="${key}">
                  <label class="custom-control-label" for="${key}">${title}
                    <br>
                    <span id="${key}Info" style="font-size: 75%; opacity: 0.75">${info}</span>
                  </label>
                </div>
                ${lockHtml}
              </div>`);
          $(`#${key}`).prop("checked", teamVal);
          $(`#${key}`).change((e) => {
            const { checked } = e.target;
            if (key === "diallerDefaultRecordingOn") {
              const oldInfo = $(`#${key}Info`).text();
              const newInfo = toggleDiallerRecordingText(oldInfo, checked);
              $(`#${key}Info`).text(newInfo);
            }
            modifyTeam({ key, val: checked });
          });

          if (lockable) {
            toggleRecordingLock(key, lockKey, res[lockKey]);
            $(`#${lockKey}`).on("click", () => {
              const lock = $(`#${lockKey}`).attr("data-value") !== "locked";
              modifyTeam({ key: lockKey, val: lock });
              toggleRecordingLock(key, lockKey, lock);
            });
          }
        });
      }

      if (showCompliance) {
        $("#v-pills-compliance-tab").show();

        const shouldShowForm = () => {
          const statuses = Object.values(complianceStatuses);
          // Show the form if not submitted before
          // or if CS (impersonating) are resubmitting a failure
          return (
            statuses.every((x) => [undefined, null].includes(x)) ||
            (cookieValue("impersonating") === "true" &&
              statuses.includes("failed"))
          );
        };
        const showForm = shouldShowForm();
        $("#complianceRegisterDiv").toggle(showForm);

        if (showForm) {
          const contact = res.contact ? res.contact : {};

          const hasCountry =
            contact && COMPLIANCE_COUNTRIES.includes(contact.countryCode);
          $("#complianceCountrySpecificDiv").toggle(hasCountry);

          $("#complianceStreetAddressInput").val(contact.streetAddress);
          $("#complianceCityInput").val(contact.city);
          $("#compliancePostcodeInput").val(contact.postcode);

          $("#complianceLegalNameInput").val(contact.legalName);
          $("#complianceTaxIdInput").val(contact.taxId);
          $("#complianceBusinessTypeSelect")
            .selectpicker("val", contact.businessType || "")
            .selectpicker("refresh");

          $("#complianceIndustrySelect")
            .selectpicker("val", contact.industry || "")
            .selectpicker("refresh");

          $("#complianceContactFirstNameInput").val(contact.firstName);
          $("#complianceContactLastNameInput").val(contact.lastName);
          $("#complianceContactEmailInput").val(contact.email);
          $("#complianceSupportEmailInput").val(contact.supportEmail);
          $("#complianceContactPhoneInput").val(contact.phone);

          $("#complianceWebsiteInput").val(contact.website);

          ["kyc", ...DIALLER_COUNTRIES].forEach((cc) => {
            if (!contact[cc]) return;
            const complianceFields = COMPLIANCE_FIELDS[cc] || {};

            (complianceFields.inputFields || []).forEach((field) => {
              $(`#compliance${capitalize(cc)}${capitalize(field)}Input`).val(
                contact[cc]?.[field],
              );
            });

            (complianceFields.selectFields || []).forEach((field) => {
              $(`#compliance${capitalize(cc)}${capitalize(field)}Select`)
                .selectpicker("val", contact[cc]?.[field] || "")
                .selectpicker("refresh")
                .trigger("change");
            });

            if (cc === "kyc") return;

            [`compliance${capitalize(cc)}`, cc].forEach((key) => {
              ADDRESS_FIELDS.inputFields.forEach((field) => {
                $(`#${key}${capitalize(field)}Input`).val(contact[cc]?.[field]);
              });
              ADDRESS_FIELDS.selectFields.forEach((field) => {
                $(`#${key}${capitalize(field)}Select`)
                  .selectpicker("val", contact[cc]?.[field])
                  .selectpicker("refresh")
                  .trigger("change");
              });
            });
          });

          const smsDisabled = !!res.includeSms && !hasDomain;
          $("#complianceRegisterSmsDiv").toggle(
            showCompliances.sms || smsDisabled,
          );
          $("#complianceRegisterSmsDisabledText").toggle(smsDisabled);
          if (smsDisabled)
            $(
              "#complianceRegisterSmsCheck, #complianceRegisterSmsLabel",
            ).addClass("disabled");

          if (hasCountry) {
            const { countryCode } = contact;
            $("#complianceCountrySelect")
              .selectpicker("val", countryCode)
              .change();

            $("#complianceBusinessTypeDiv").toggle(countryCode !== "GB");

            COMPLIANCE_COUNTRIES.forEach((code) => {
              const stateDiv = $(`#compliance${code}StateDiv`);
              const stateSelect = $(`#compliance${code}StateSelect`);

              stateDiv.toggle(countryCode === code);

              if (stateDiv.is(":visible")) {
                stateSelect.attr("required", "required");
              } else {
                stateSelect.removeAttr("required");
              }

              stateSelect.selectpicker("val", contact.state);
            });

            const BUSINESS_REGISTER_MAP = {
              AU: "Company Number from ASIC",
              AE: "Company Registration Number",
              CA: "Business Number",
              DE: "Company Registration Number",
              DK: "CVR Number",
              GB: "Company Number",
              IE: "Company Registration Number",
              NL: "KVK number",
              US: "EIN",
            };
            $("#complianceTaxIdText").html(BUSINESS_REGISTER_MAP[countryCode]);
          }
        } else {
          Object.entries(complianceStatuses).forEach(([key, val]) => {
            $(`#${key}ApprovedDiv`).toggle(val === "approved");
            $(`#${key}PendingDiv`).toggle(val === "pending");
            $(`#${key}FailedDiv`).toggle(val === "failed");

            if (!["sms", "kyc"].includes(key)) return;

            $(`#${key}RegisterDiv`).toggle(
              !["approved", "pending", "failed"].includes(val),
            );
          });

          $(`#smsCustomDomainDiv`).toggle(
            !!res.includeSms && !showCompliances.sms && !hasDomain,
          );
        }
      } else if (res.includeSms && !hasDomain) {
        $("#v-pills-compliance-tab").show();
        $(`#smsCustomDomainDiv`).show();
        $("#complianceRegisterDiv").hide();
      }

      if (res.stripeCustomerId) {
        $("#billingDiv").show();
        if (!res.organizationId) $("#managePaymentMethodsDiv").show();
      }

      $("[data-toggle=tooltip]").tooltip();
    },
  });
};

const renameGroup = (target) => {
  const newName = target.val();
  if (target.attr("value") === newName) return;

  const data = {
    groupId: target.attr("data-id"),
    groupName: newName,
    action: "rename",
  };

  wrappedPost({
    url: "/api/admin/modify",
    data: JSON.stringify({ kind: "team-group", data }),
    success: () => {
      showToast({
        title: "Group successfully renamed",
        type: "success",
      });
      refreshTables();
    },
  });
};

const setAddSeatDefaults = (kind) => {
  const selector = {
    user: "#addUserSeatsInput",
    superUser: "#addUserSeatsInput",
    alias: "#addAliasSeatsInput",
    viewer: "#addViewerSeatsInput",
  }[kind];

  $(".user-seat-input").val(0);
  $(selector).val(1);
};

const modifyUserKind = (kind, data) => {
  const callback = () =>
    wrappedPost({
      url: "/api/admin/modify",
      data: JSON.stringify({ kind, data }),
      success: () => {
        showToast({
          title: "User successfully updated",
          type: "success",
        });
        refreshTables();
        $("#modifyUserModal").modal("hide");
      },
      error: (err) => {
        if (err.status === 402) {
          $("#addSeatsModal").modal("show");
          setAddSeatDefaults(kind);
        }
      },
      spinner: "#modifyUserSaveButton",
    });

  if (data.kind === "alias") {
    $("#modifyUserModal").modal("show");
    $("#modifyUserSaveButton")
      .off("click")
      .click(() => {
        data.aliasUserId = $("#modifyUserAliasUserSelect").selectpicker("val");
        callback();
      });
  } else {
    callback();
  }
};

const USER_KIND_MAP = {
  user: "User",
  superUser: "Super User",
  viewer: "Viewer",
  alias: "Alias",
  trial: "Trial",
};

const PAYMENT_METHOD_ICONS = {
  card: "<i class='fa-lg fa-regular fa-credit-card text-primary'></i>",
  us_bank_account:
    "<i class='fa-lg fa-regular fa-building-columns text-primary'></i>",
  bacs_debit:
    "<i class='fa-lg fa-regular fa-building-columns text-primary'></i>",
  link: "<img class='paymentMethodImg' src='/assets/img/billing/link.svg'/>",
};

const resetMoveUserModal = (show) => {
  $("#move-warning").toggle(show);
  $("#move-warning-between-teams").toggle(!show);
  $("#moveUserTeamBtn").toggle(show);
  $("#moveUserBtns").toggle(!show);
};

const chartData = {
  colors: chartColors,
  chart: {
    width: "100%",
    height: 350,
    animations: { speed: 800, animateGradually: { delay: 50 } },
    toolbar: { show: false },
    fontFamily: "inherit",
  },
  dataLabels: { enabled: false },
  noData: { text: "Loading..." },
};

const setDonutChartData = (values) => {
  chartData.labels = values.map((x) => x[0]);
  chartData.series = values.map((x) => x[1]);
  chartData.legend = "none";
  chartData.plotOptions = {
    pie: {
      donut: {
        labels: {
          show: true,
          total: {
            show: true,
            showAlways: true,
            label: "Total",
            fontSize: "1.5rem",
          },
        },
      },
    },
  };
};

const setBarChartData = (values) => {
  if (chartData.legend) delete chartData.legend;
  chartData.xaxis = { categories: values.map((x) => x[0]) };
  chartData.series = [{ data: values.map((x) => x[1]) }];
};

let chartType = "donut";

const updateCharts = (res) => {
  $("#chartsContainer").empty();

  Object.entries(res).forEach(([provider, values]) => {
    chartData.id = provider;
    chartData.chart.type = chartType;

    if (chartType === "donut") setDonutChartData(values);
    else if (chartType === "bar") setBarChartData(values);

    const noChartData = chartData.series.every((x) => x === 0);

    if (noChartData) return;

    $("#chartsContainer").append(/* html */ `
        <div id="chart-col-${provider}" class="col-6 mt-4">
          <div class="card card-alt">
            <div class="card-header pt-3 pb-0">
              <p class="m-0">${provider} Credit Usage</p>
            </div>
            <div class="card-body">
              <div id="chart${provider}"></div>
            </div>
          </div>
        </div>
      `);

    const chart = new ApexCharts(
      document.querySelector(`#chart${provider}`),
      chartData,
    );
    chart.render();
  });

  $("#noChartData").toggle($("#chartsContainer").is(":empty"));
};

let CREDITS_DATA = {};

const datePickerValues = () => {
  const from = new Date(getStartDate(".datepicker input"));
  const to = new Date(getEndDate(".datepicker input"));

  from.setUTCHours(0, 0, 0, 0);
  to.setUTCHours(23, 59, 0, 0);

  return { from, to };
};

const updateCreditUsageStats = () => {
  const dates = datePickerValues();

  const start = dates.from.toISOString().replace(/:00.000/, "");
  const end = dates.to.toISOString().replace(/:00.000/, "");

  wrappedGet({
    url: "/api/admin/get_user_credit_usage",
    data: { start, end },
    success: (res) => {
      CREDITS_DATA = res;
      updateCharts(CREDITS_DATA);
    },
  });
};

const downloadCreditUsage = () => {
  Object.entries(CREDITS_DATA).forEach(([name, data]) => {
    data.sort();

    const fromDate = moment(datePickerValues().from).format("DD MMM YYYY");
    const toDate = moment(datePickerValues().to).format("DD MMM YYYY");
    const date = `${fromDate} - ${toDate}`;

    const csv = Papa.unparse({ fields: ["Name", "Credit Usage"], data });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
    window.saveAs(blob, `Credit Usage - ${name} (${date}).csv`);
  });
};

const notInterestedExamples = [
  [
    "commute",
    "If they are not interested in the commute distance or time required for the job",
  ],
  [
    "benefits",
    "If they are not interested in the benefits offered by the company",
  ],
  [
    "company size",
    "If they are not interested in working for a large or small company",
  ],
  [
    "job type",
    "If they are not interested in a certain type of job, such as remote work or part-time work",
  ],
  [
    "religious observance",
    "If the schedule of the job does not accommodate their religious observance",
  ],
  ["relocation", "If they are not willing or able to relocate for the job"],
  [
    "certification",
    "If they do not have the necessary certifications for the job",
  ],
  [
    "security clearance",
    "If they do not have the required security clearance for the job",
  ],
  [
    "shift work",
    "If they are not interested in jobs that require working outside of regular business hours",
  ],
  ["language", "If they are not fluent in a language required for the job"],
  [
    "commitment",
    "If they are not interested in a long-term commitment or a permanent position",
  ],
  ["culture", "If they are not interested in the company culture or values"],
  ["travel", "If they are not interested in jobs that require frequent travel"],
  ["remote work", "If they are not interested in remote work, or vice versa"],
];

const setNotInterestedButtonVisibility = () => {
  $(".remove-not-interested-reason").removeClass("disabled");
  $("#add-not-interested-reason").removeClass("disabled");

  const numNotInterestedReasons = $(".not-interested-reason").length;

  if (numNotInterestedReasons === 1) {
    $(".remove-not-interested-reason").addClass("disabled");
  }

  if (numNotInterestedReasons >= 8) {
    $("#add-not-interested-reason").addClass("disabled");
  }
};

const addInterestedReason = (id = "", tag = "", desc = "") => {
  const randomExample =
    notInterestedExamples[
      Math.floor(Math.random() * notInterestedExamples.length)
    ];

  $("#notInterestedReasonsTable tbody").append(/* html */ `
      <tr class="not-interested-reason" data-id=${id}>
        <td class="tag">
          <input type="text" class="form-control" placeholder='Try "${randomExample[0]}"' value="${tag}" />
        </td>
        <td class="description">
          <input
            type="text"
            class="form-control"
            placeholder='Try "${randomExample[1]}"'
            value="${desc}"
          />
        </td>
        <td class="buttons">
          <a class="remove-not-interested-reason not-interested-reason-button pl-2"
            ><i class="fa-regular fa-circle-minus"></i
          ></a>
        </td>
      </tr>
    `);

  setNotInterestedButtonVisibility();
};

const saveActivityFeedSettings = ({ restrictDomains }) => {
  wrappedPost({
    url: "/api/admin/modify",
    data: JSON.stringify({ kind: "team", data: { restrictDomains } }),
    success: () => {
      showToast({ title: "Changes Saved", type: "success" });
      modifyTeam({ key: "restrictActivityFeed", val: false });
    },
    spinner: "#activityFeedSaveBtn",
  });
};

/* PURCHASING DIALLER */

const USER = getUser();

const regionsToText = (regions) => {
  const MAP = { GB: "UK", US: "USA", CA: "Canada" };
  const arr = regions.split(",").map((r) => MAP[r.trim()] || r.trim());

  if (arr.length === 1) return arr[0];

  const last = arr.pop();
  return `${arr.join(", ")} and ${last.trim()}`;
};

const synchronizeNavStateAndHash = () => {
  // Setup a correspondence between the active .nav element and the
  // page hash
  const navObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        const wasActive = mutation.oldValue.split(" ").includes("active");
        const isActive = mutation.target.className.includes("active");
        if (isActive && !wasActive) {
          const { href = "#" } = mutation.target;
          const x = href.split("#")[1] || "";
          window.location.hash = x.replace("v-pills-", "");
        }
      }
    });
  });

  $("#admin-tabs-div > .nav > .nav-link")
    .toArray()
    .forEach((el) => {
      navObserver.observe(el, {
        attributes: true,
        attributeOldValue: true,
      });
    });

  const handleHashChange = (e) => {
    const { hash = "" } = window.location;
    const tabId = hash.replace("#", "v-pills-");
    const $nav = $(`#${tabId}-tab`);

    if ($nav.length === 0) {
      const oldHash = e?.oldURL.split("#")[1] || "users";
      window.location.hash = oldHash;
      return;
    }
    if (!$nav.hasClass("active")) {
      // avoid infinite loop
      $nav.click();
    }
  };
  window.addEventListener("hashchange", handleHashChange);
  handleHashChange();
};

export const initializeAdmin = () => {
  if (tab) {
    const $nav = $(`#v-pills-${tab}-tab`);
    if ($nav.length > 0) {
      // if the tab query param was valid, click it.
      $nav.click();
      window.location.hash = tab;
    }
    urlParams.delete("tab");
    if (urlParams.size > 0) {
      // query params left, update the url
      window.location.search = urlParams.toString();
    } else {
      // no query params left, remove the ? from the url
      window.history.replaceState(
        {},
        document.title,
        `${window.location.pathname}#${tab}`,
      );
    }
  }
  const user = getUser();
  const modularized = user.licenses;
  if (modularized) {
    $(".seats-used").parent().parent().parent().hide();
    bindLicenseComponents();
    $("#v-pills-users-tab").html(
      '<i class="fa-regular fa-fw fa-users mr-2"></i>Users & Licenses',
    );
  } else {
    $("#user-licenses-tab").parent().remove();
  }

  const hasNotetaker = ["standard", "trial", "admin"].includes(
    getUser().notetakerPlan,
  );
  if (!hasNotetaker) {
    $("#v-pills-notetaker").remove();
    $("#v-pills-notetaker-tab").remove();
  }

  const hasInboxAgentDraftAI = modularized || getUser().inboxAgentDraftAI;

  if (!hasInboxAgentDraftAI) {
    $("#v-pills-inbox-agent-draft-ai").remove();
    $("#v-pills-inbox-agent-draft-ai-tab").remove();
  }

  if (urlParams.get("paymentSuccess")) {
    showToast({
      title: "Payment successful!",
      type: "success",
      timeout: 30000,
    });
  }

  $("#checkRecordsBtn").click(() => {
    checkCustomDomain();
  });

  $("#restrictDomainsInput").tokenfield({
    createTokensOnBlur: true,
    inputType: "text",
  });

  $(document).on("hidden.bs.dropdown", ".teamGroup-user-selector", (event) => {
    const target = $(event.target).find(".selectpicker");
    const data = {
      groupId: target.attr("data-id"),
      userIds: target.val(),
      action: "update",
    };
    if (data.userIds.length === 0) {
      const msg = `${data.groupId} must have at least one member`;
      showToast({ title: msg, type: "warning" });
      refreshTables();
      return;
    }

    const current = TEAM_GROUP_DICT[data.groupId].users.map((x) => x.userId);
    if (JSON.stringify(current.sort()) === JSON.stringify(data.userIds.sort()))
      return;

    wrappedPost({
      url: "/api/admin/modify",
      data: JSON.stringify({ kind: "team-group", data }),
      success: () => {
        showToast({
          title: "Group successfully modified",
          type: "success",
        });
        refreshTables();
      },
    });
  });

  $(document).on("focusout", "#group-name-input", (event) => {
    renameGroup($(event.target));
  });

  $(document).on("keyup", "#group-name-input", (event) => {
    if (event.key !== "Enter") return;
    const target = $(event.target);
    renameGroup(target);
    target.blur();
  });

  $(document).on("click", `.remove-team-group-btn`, (event) => {
    const groupName = $(event.target).attr("data-name");
    const data = {
      groupId: $(event.target).attr("data-id"),
      action: "delete",
    };
    wrappedPost({
      url: "/api/admin/modify",
      data: JSON.stringify({ kind: "team-group", data }),
      success: () => {
        showToast({
          title: `${groupName} successfully deleted`,
          type: "success",
        });
      },
    });
  });

  $(document).on(
    "change",
    "#usersTable input[type='checkbox'][data-kind]",
    (event) => {
      const userId = $(event.target).attr("data-userId");
      const data = { userId };

      const key = $(event.target).attr("data-kind");
      data[key] = $(event.target).is(":checked");

      wrappedPost({
        url: "/api/admin/modify",
        data: JSON.stringify({ kind: "user", data }),
        success: () => {
          showToast({ title: "Changes saved", type: "success" });
        },
      });
    },
  );

  ["fontFamily", "defaultFontSize"].forEach((key) => {
    $(`#${key}`).change((e) => {
      modifyTeam({ key, val: $(e.target).selectpicker("val") });
    });
  });

  const updateWarmUpMessage = (start, perDay, daysLeft) => {
    const newLimit =
      parseInt(start, 10) + parseInt(perDay, 10) * parseInt(daysLeft, 10);
    $("#sendLimitWarning").show();
    const text = `Please note, this user has the email warm up feature turned on, and so their daily sending limit will reach ${newLimit} in ${daysLeft} days.`;
    $("#sendLimitWarningText").text(text);
  };

  const warmUpSliderSpinner = (user) => {
    const show = user?.warmUpDaysLeft > 0 && user?.warmUpPerDay > 0;
    const input = `#sendLimitInput`;
    const output = `#sendLimitOutput`;

    const update = () => {
      refreshLimitInput();
      $(input).tooltip("show");
      if (show) {
        const start = $("#sendLimitOutput").val();
        updateWarmUpMessage(start, user?.warmUpPerDay, user?.warmUpDaysLeft);
      } else {
        $("#sendLimitWarning").hide();
        $("#sendLimitWarningText").text("");
      }
    };

    update();

    $(input)
      .off("input change")
      .on("input change", () => {
        update();
      });

    $(output)
      .off("input")
      .on("input", (e) => {
        let value = e.target.value.replace(/[^0-9]/g, "");
        value = Math.min(
          Math.max(value, $(input).attr("min")),
          $(input).attr("max"),
        );
        $(`${input}, ${output}`).val(value);
        update();
      });

    $(`${input}, ${output}`)
      .off("focus blur")
      .on("focus blur", (e) => {
        $(input).tooltip(e.type === "focus" ? "show" : "hide");
      });
  };

  $("#usersTable")
    .DataTable({
      bLengthChange: false,
      buttons: [
        {
          extend: "csv",
          className: "btn-light ml-2",
          text: '<i class="fa-regular fa-download"></i>',
          exportOptions: {
            orthogonal: "export",
            columns: ":not(.no-export)",
          },
          filename: "SourceWhale Users",
          extension: ".csv",
          attr: {
            "data-toggle": "tooltip",
            title: "Download CSV",
          },
        },
        {
          attr: {
            id: "addUserButton",
            "data-toggle": "tooltip",
            title: "Add Users",
          },
          className: "btn btn-primary ml-2",
          text: '<i class="fa-regular fa-user-plus"></i>',
        },
      ],
      columns: [
        {
          data: (x) => x,
          searchable: true,
          render: (user, type) => {
            const missingAliasUser =
              user.kind === "alias" && !USER_DICT[user.aliasUserId];
            if (type === "display" || type === "filter") {
              return missingAliasUser
                ? wrapTooltip(
                    `<i class="fas fa-circle-exclamation missing-alias-user" data-userId="${user.userId}" style="cursor: pointer"></i>`,
                    "Missing Alias User",
                  )
                : "";
            }
            return missingAliasUser ? "Missing Alias User" : "";
          },
        },
        {
          title: "User",
          data: (x) => x,
          searchable: true,
          render: (user, type) => {
            if (type === "display" || type === "filter") {
              const namePhoto = nameAndPhoto(user.name, user.picture);
              return `${namePhoto}<p class="my-0" style="font-weight: 300">${user.email}</p>`;
            }
            return user.name;
          },
        },
        {
          title: "User Email",
          data: (x) => x,
          render: (user) => user.email,
        },
        {
          title: "Groups",
          data: (x) => x,
          searchable: true,
          render: (user, type) => {
            if (type !== "type") {
              // Excluding type "type" as this is used internally by DataTables so could maybe cause unexpected behavior
              const teamGroups = Object.keys(TEAM_GROUP_DICT).length
                ? TEAM_GROUP_DICT
                : getUser().teamGroups;

              if (!teamGroups || Object.keys(teamGroups).length === 0)
                return "No Group";

              let selectHTML = `<div class="dropdown round-right round-left" style="width:180px">
                  <select class="selectpicker team-groups-selector" multiple data-userId="${user.userId}" title="No Group">`;

              const selectedGroups = [];

              Object.keys(teamGroups).forEach((groupId) => {
                const isSelected = user.teamGroupIds.includes(groupId)
                  ? "selected"
                  : "";

                selectHTML += `<option ${isSelected} value="${groupId}">${teamGroups[groupId].groupName}</option>`;

                if (isSelected)
                  selectedGroups.push(teamGroups[groupId].groupName);
              });

              selectHTML += `</select></div>`;

              if (type === "export") return selectedGroups.join(", ");

              return selectHTML;
            }
            return user.kind;
          },
        },
        {
          title: "User Type",
          data: (x) => x,
          render: (user, type) => {
            const trialOption =
              user.kind === "trial"
                ? `<option selected value="trial" data-subtext="until ${user.pauseDate}">Trial</option>`
                : "";
            if (type === "display" || type === "filter") {
              return `
            <div class="dropdown round-right round-left" style="min-width:150px">
              <select class="selectpicker user-kind-selector" data-userId="${
                user.userId
              }">
                ${trialOption}
                <option ${
                  user.kind === "user" ? "selected" : ""
                } value="user" data-subtext="A normal user, capable of performing all the usual functions in SourceWhale">User</option>
                <option ${
                  user.kind === "superUser" ? "selected" : ""
                } value="superUser" data-subtext="All the permissions of a user, plus the ability to edit teammate's campaigns and send from them">Super-User</option>
                <option ${
                  user.kind === "viewer" ? "selected" : ""
                } value="viewer" data-subtext="Can see everything a user can see, but can't make any changes.">Viewer</option>
                <option ${
                  user.kind === "alias" ? "selected" : ""
                } value="alias" data-subtext="An account from which another account can send emails. Cannot access SourceWhale itself.">Alias</option>
              </select>
            </div>`;
            }
            return user.kind;
          },
        },
        {
          title: "<div class='text-center'>Admin Access</div>",
          data: (x) => x,
          render: (user, type) => {
            const id = uuidV4();
            if (type === "display" || type === "filter")
              return `
                <div class="custom-control custom-switch text-center">
                  <input class="custom-control-input is-admin-checkbox" type="checkbox" data-kind="isAdmin" data-userId="${
                    user.userId
                  }" ${user.isAdmin ? "checked" : ""} id="${id}">
                    <label class="custom-control-label" for="${id}"></label>
                </div>`;

            return user.isAdmin ? "Admin Access" : "";
          },
        },
        {
          title:
            "<div class='text-center'>Manager<i class='fa-regular fa-circle-info ml-1' data-toggle='tooltip' title='When enabled, this user will receive SourceWhale communications specific to their role as a team manager.'></i></div>",
          data: (x) => x,
          render: (user, type) => {
            const id = uuidV4();
            if (type === "display" || type === "filter")
              return `
                <div class="custom-control custom-switch text-center">
                  <input class="custom-control-input is-manager-checkbox" type="checkbox" data-kind="isManager" data-userId="${
                    user.userId
                  }" ${user.isManager ? "checked" : ""} id="${id}">
                    <label class="custom-control-label" for="${id}"></label>
                </div>`;

            return user.isManager ? "Manager" : "";
          },
        },
        {
          data: (x) => x,
          render: (user) =>
            [
              wrapTooltip(
                `<button class="btn btn-light move-user-team-btn m-1" type="button" data-userId="${user.userId}" data-email="${user.email}" style="display: none"><i class="fas fa-users-class"></i></button>`,
                "Move to another team",
              ),
              wrapTooltip(
                `<button class="btn btn-light move-user-data-btn m-1" type="button" data-userId="${user.userId}" data-email="${user.email}"><i class="fas fa-share"></i></button>`,
                "Transfer data to another user",
              ),
              wrapTooltip(
                `<button class="btn btn-light modify-btn m-1" type="button" data-userId="${user.userId}"><i class="fa-regular fa-cog"></i></button>`,
                "Edit user settings",
              ),
              wrapTooltip(
                `<button class="btn btn-light delete-btn m-1" type="button" data-userId="${user.userId}"><i class="fa-regular fa-times text-danger"></i></button>`,
                "Delete user",
              ),
            ].join(""),
        },
      ],
      columnDefs: [
        { targets: "_all", orderable: false, searchable: false },
        { targets: -1, className: "no-export" },
        { targets: 2, visible: false },
      ],
      deferRender: true,
      dom: `
          <'row'
            <'col table-nav d-flex align-items-center' fB>
          >
          <'row'
            <'col-12'r>
          >
          <'row'
            <'col-12 pt-3't>
          >
          <'row d-flex align-items-center'
            <'col-4'i>
            <'col-4 text-center'l>
            <'col-4'p>
          >`,
      language: {
        search: '<i class="fa-regular fa-search" aria-hidden="true"></i>',
        searchPlaceholder: "Search by name or email",
        emptyTable: "No matching records found",
      },
    })
    .on("draw", () => {
      $('[data-toggle="tooltip"]')
        .tooltip("dispose")
        .tooltip({ html: true, target: "hover" });

      $("#usersTable .selectpicker").selectpicker();

      if (getUser().organizationId) $("#usersTable .move-user-team-btn").show();

      $("#usersTable .modify-btn, .missing-alias-user")
        .off("click")
        .click((e) => {
          const userId = $(e.currentTarget).attr("data-userId");
          const user = USER_DICT[userId];

          const isAlias = user.kind === "alias";

          const rowData = $("#usersTable")
            .DataTable()
            .row($(e.currentTarget).parents("tr"))
            .data();

          $("#editUserEmailHeading").text(user.email);
          $("#sendLimitInput").val(user.sendLimit);
          $("#minGapInput").val(user.minGap);

          warmUpSliderSpinner(user);
          refreshLimitInput();
          refreshGapInput();

          $("#editUserModal").modal("show");

          $("#aliasUserSelect").find("option").remove();

          $("#usersTable")
            .DataTable()
            .rows()
            .data()
            .toArray()
            .filter((x) => ["user", "superUser"].includes(x.kind))
            .sort((a, b) =>
              a.email.toLowerCase().localeCompare(b.email.toLowerCase()),
            )
            .forEach((row) => {
              $("#aliasUserSelect").append(
                `<option value="${row.userId}">${row.email}</option>`,
              );
            });

          $("#aliasUserSelect").selectpicker("refresh");
          $("#aliasUserSelect").selectpicker("val", user.aliasUserId);

          $("#aliasUserSelectDiv").toggle(isAlias);

          $("#editUserSaveButton")
            .off("click")
            .click(() => {
              const data = {
                userId,
                sendLimit: $("#sendLimitInput").val(),
                minGap: $("#minGapInput").val(),
              };

              if (isAlias)
                data.aliasUserId = $("#aliasUserSelect").selectpicker("val");

              wrappedPost({
                url: "/api/admin/modify",
                data: JSON.stringify({ kind: "user", data }),
                success: () => {
                  showToast({
                    title: "Changes saved",
                    type: "success",
                  });
                  $("#editUserModal").modal("hide");

                  rowData.sendLimit = data.sendLimit;
                  rowData.minGap = data.minGap;

                  if (isAlias) rowData.aliasUserId = data.aliasUserId;
                },
                spinner: "#editUserSaveButton",
              });
            });
        });

      $("#usersTable .team-groups-selector.selectpicker").on(
        "changed.bs.select",
        (e, _, isSelected, previousValue) => {
          $(e.target).selectpicker("toggle");
          const groupIds = $(e.target).val();

          let deselectedId = null;
          if (!isSelected && previousValue) {
            const previousGroupIds = Array.isArray(previousValue)
              ? previousValue
              : [previousValue];
            deselectedId = previousGroupIds.find(
              (id) => !groupIds.includes(id),
            );
          }

          $(".team-groups-selector").addClass("disabled");
          wrappedPost({
            url: "/api/admin/modify",
            data: JSON.stringify({
              kind: "team-group",
              data: {
                groupIds,
                deselectedId,
                userId: $(e.target).attr("data-userId"),
                action: "updateSingle",
              },
            }),
            success: () => {
              showToast({
                title: "User successfully updated",
                type: "success",
              });
              refreshTables($("#teamGroupSelector").val());
              $(".team-groups-selector").removeClass("disabled");
            },
          });
        },
      );

      $("#usersTable .user-kind-selector").change((e) => {
        const userId = $(e.currentTarget).attr("data-userId");
        if (!userId) return;

        const user = USER_DICT[userId];
        const newKind = e.target.value;

        const changingFromViewer = user.kind === "viewer";
        const changingToFullUser = ["user", "superUser"].includes(newKind);
        const hasNoSignInLicenses =
          user.licenses &&
          !user.licenses.some((license) => SIGN_IN_LICENSES.includes(license));

        if (changingFromViewer && changingToFullUser && hasNoSignInLicenses) {
          assignLicenseModalProps.set({
            show: true,
            userId,
            kind: newKind,
            originalLicenses: user.licenses,
          });
          return;
        }

        modifyUserKind("user", { userId, kind: newKind });
      });

      $("#usersTable .delete-btn")
        .off("click")
        .click((e) => {
          const userId = $(e.currentTarget).attr("data-userId");
          const { email } = USER_DICT[userId];
          const dialerMsg = teamHasDialler(false)
            ? ` Any assigned numbers for this user in the SourceWhale Dialer will be permanently removed.`
            : "";
          const msg = `If you wish to make changes to your billing, please contact your CSM.${dialerMsg} Remove ${email}?`;
          yesNoConfirm(msg, () =>
            wrappedPost({
              url: "/api/admin/delete",
              data: JSON.stringify({ kind: "user", data: { userId } }),
              success: () => {
                showToast({
                  title: `Removed ${email}`,
                  type: "success",
                });
                refreshTables();
              },
            }),
          );
        });
    });

  $("#teamGroupSelectorWrapper").insertBefore(".dt-buttons");

  $("#userInvitesTable")
    .DataTable({
      bLengthChange: false,
      buttons: [
        {
          extend: "csv",
          className: "btn-light ml-2",
          text: '<i class="fa-regular fa-download"></i>',
          exportOptions: { orthogonal: "export" },
          filename: "SourceWhale Invitations",
          extension: ".csv",
        },
      ],
      columns: [
        {
          data: "replaceUserId",
          render: (replaceUserId) => {
            const replaceUser = USER_DICT[replaceUserId];
            return replaceUser
              ? wrapTooltip(
                  `<i class="fas fa-exclamation text-danger"></i>`,
                  `Replacing ${replaceUser.email}`,
                )
              : "";
          },
          searchable: false,
        },
        {
          data: "email",
          render: (email) => `<i class="fas fa-user mr-2"></i>${email}`,
          searchable: true,
        },
        {
          data: "timestamp",
          render: (timestamp, type) =>
            ["display", "filter"].includes(type)
              ? localDateTimeString(timestamp)
              : timestamp,
          searchable: false,
        },
        {
          data: "kind",
          render: (kind) => USER_KIND_MAP[kind],
          searchable: false,
        },
        {
          data: "email",
          className: "text-right",
          render: (email) =>
            wrapTooltip(
              ` <button class="btn btn-light  delete-btn" type="button" data-email="${email}">
                    <i class="fa-regular fa-times text-danger"></i>
                  </button>`,
              "Delete Invitation",
            ),
          searchable: false,
        },
      ],
      columnDefs: [{ targets: "_all", orderable: false }],
      deferRender: true,
      dom: `
        <'row'
          <'col table-nav d-flex align-items-center' fB>
        >
        <'row'
          <'col-12't>
          <'col-12'r>
        >
        <'row d-flex align-items-center'
          <'col-4'i>
          <'col-4 text-center'l>
          <'col-4'p>
        >`,
      language: {
        search: '<i class="fa-regular fa-search" aria-hidden="true"></i>',
        searchPlaceholder: "Search",
      },
    })
    .on("draw", () => {
      $("#userInvitesTable .selectpicker").selectpicker();

      $('[data-toggle="tooltip"]')
        .tooltip("dispose")
        .tooltip({ html: true, target: "hover" });

      $("#userInvitesTable .user-kind-selector").change((e) => {
        const email = $(e.currentTarget).attr("data-email");
        if (!email) return;
        modifyUserKind("user-invite", { email, kind: e.target.value });
      });

      $("#userInvitesTable .delete-btn")
        .off("click")
        .click((e) => {
          const email = $(e.currentTarget).attr("data-email");
          const msg = `Remove ${email}?`;
          yesNoConfirm(msg, () =>
            wrappedPost({
              url: "/api/admin/delete",
              data: JSON.stringify({ kind: "user-invite", data: { email } }),
              success: () => {
                showToast({
                  title: `Removed ${email}`,
                  type: "success",
                });
                refreshTables();
              },
            }),
          );
        });
    });

  $("#createTeamGroupBtn").click(() => {
    fillTeamGroupSelector($("#createTeamGroupUserSelector"), []);
    $("#createTeamGroupModal").modal("show");
  });

  $("#saveTeamGroupBtn").click(() => {
    $("#createTeamGroupUsersDropdown").removeClass("warning-border-no-padding");
    const groupName = $("#teamGroupName").val();
    const userIds = $(`#createTeamGroupUserSelector`).val();

    if (groupName === "") {
      const msg = `Please give this group a name`;
      backdropAlert(msg);
      return;
    }

    if (userIds.length === 0) {
      const msg = `${groupName} must have at least one member`;
      backdropAlert(msg);
      return;
    }

    const existing = Object.values(TEAM_GROUP_DICT).map((x) => x.groupName);
    if (existing.includes(groupName)) {
      const msg = `${groupName} already exists`;
      showToast({ title: msg, type: "warning" });
    }

    wrappedPost({
      url: "/api/admin/create",
      data: JSON.stringify({
        kind: "team-group",
        data: { groupName, userIds },
      }),
      success: () => {
        refreshTables();
        showToast({
          title: `${groupName} successfully created`,
          type: "success",
        });
        $("#teamGroupName").val("");
        $("#createTeamGroupModal").modal("hide");
      },
    });
  });

  $("#minGapInput").change((e) => {
    refreshGapInput();
    $(e.target).tooltip("show");
  });

  $("#minGapInput").blur((e) => {
    $(e.target).tooltip("hide");
  });

  $("#minGapInput").focus((e) => {
    $(e.target).tooltip("show");
  });

  $("#addUserButton").click(() => {
    if (modularized) {
      showAddUsersModal.set(true);
    } else {
      $("#addUserModal").modal("show");
    }
  });

  $("#addUserPermissionsSelect").selectpicker();

  $("#addUserPermissionsSelect").change(() => {
    const val = $("#addUserPermissionsSelect").selectpicker("val");
    $("#addUserAliasUserDiv").toggle(val === "alias");
    $("#addUserAdminDiv").toggle(val !== "alias");
  });

  $("#addUserSaveButton").click(() => {
    const email = $("#addUserEmailInput").val();
    if (!email.length) {
      backdropAlert("Please enter an email address");
      return;
    }

    const data = {
      email,
      kind: $("#addUserPermissionsSelect").selectpicker("val"),
      aliasUserId: $("#addUserAliasUserSelect").selectpicker("val"),
      isAdmin: $("#addUserAdminCheckbox").is(":checked"),
      groupIds: $("#addUserTeamGroupsSelect").selectpicker("val"),
    };
    wrappedPost({
      url: "/api/admin/create",
      data: JSON.stringify({ kind: "user-invite", data }),
      success: () => {
        showToast({ title: `Invited ${email}`, type: "success" });
        refreshTables();
        $("#addUserEmailInput").val("");
        $("#addUserModal").modal("hide");
      },
      error: (err) => {
        if (err.status === 402) {
          $("#addSeatsModal").modal("show");
          setAddSeatDefaults(data.kind);
        }
      },
      spinner: "#addUserSaveButton",
    });
  });

  if (getUser().refreshDay) {
    $("#refreshDay").text(getUser().refreshDay);
    $("#refreshNotice").show();
  }

  $("#managePaymentMethodsBtn").click(() => {
    $("#paymentMethodsDiv").empty();
    addSpinner("#addPaymentMethodBtn");
    $("#addPaymentMethodModal").modal("show");

    wrappedPost({
      url: "/api/admin/payment_methods",
      data: JSON.stringify({ action: "get" }),
      success: (res) => {
        const { method } = res;

        if (method) {
          const { type, title, text } = method;
          const icon =
            PAYMENT_METHOD_ICONS[type] || "fa-regular fa-credit-card";
          $("#paymentMethodsDiv").append(`
              <div class="row ml-2 mb-2 align-items-center">
                <div class="paymentMethodIcon mr-3 d-flex align-items-center justify-content-center">${icon}</div>
                <span style="max-width: calc(100% - 4.5rem);"><strong>${title}</strong><br>${text}</span>
              </div>
              `);
        } else {
          $("#paymentMethodsDiv").append(
            `<div class="row ml-2 mb-2 align-items-center">You currently have no default payment method set up</div>`,
          );
        }
        removeSpinner("#addPaymentMethodBtn");

        $("#addPaymentMethodBtn")
          .off("click")
          .on("click", () => {
            const currentDefault = method ? method.type : undefined;
            wrappedPost({
              url: "/api/admin/payment_methods",
              data: JSON.stringify({ action: "add", currentDefault }),
              success: (ret) => {
                window.location = ret.url;
              },
              spinner: "#addPaymentMethodBtn",
            });
          });
      },
    });
  });

  wrappedGet({
    url: "/api/admin/get_invoices",
    success: (res) => {
      if (res.length) $("#invoicesDiv").show();
      const selector = $("#invoiceSelect");
      res.forEach((invoice) => {
        selector.append(
          $("<option>", {
            value: invoice.InvoiceID,
            text: invoice.DateString.split("T")[0],
            "data-subtext": invoice.InvoiceNumber,
          }),
        );
      });
      selector.selectpicker("refresh");
    },
  });

  $("#invoiceDownloadBtn").click(() => {
    const invoiceIds = $("#invoiceSelect").selectpicker("val");
    if (!invoiceIds || invoiceIds.length === 0) {
      showToast({ title: "Please select an invoice" });
      return;
    }
    invoiceIds.forEach((invoiceId) => {
      window.open(`/api/admin/get_invoice?invoiceId=${invoiceId}`);
    });
  });

  $(document).on("click", "#usersTable .move-user-data-btn", (e) => {
    const userId = $(e.currentTarget).attr("data-userId");

    $("#moveUserDataFromSelect").selectpicker("val", userId);
    $("#moveUserDataToSelect").selectpicker("val", "");

    $("#moveUserDataModal").modal("show");

    $("#moveUserDataBtn")
      .off("click")
      .click(() => {
        const data = {
          oldUserId: $("#moveUserDataFromSelect").selectpicker("val"),
          newUserId: $("#moveUserDataToSelect").selectpicker("val"),
          newEmail: $("#newEmailAddressInput").val(),
        };

        if (!data.newUserId) {
          backdropAlert("Please select a user to move data to");
          return;
        }

        if (data.newUserId === "newUser" && !data.newEmail) {
          backdropAlert("Please select an email for the user");
          return;
        }

        if (data.newUserId === data.oldUserId) {
          backdropAlert(
            "Please choose two different users to move data between",
          );
          return;
        }

        wrappedPost({
          url: "/api/admin/modify",
          data: JSON.stringify({ kind: "move-user-data", data }),
          success: () => {
            const messages = {
              newUser: {
                title: `Your data will be moved to ${data.newEmail} when they sign in`,
                subTitle: "",
              },
              existingUser: {
                title: "Your data is being moved",
                subTitle: "This may take a few minutes",
              },
            };

            const msg =
              data.newUserId === "newUser"
                ? messages.newUser
                : messages.existingUser;

            showToast({
              title: msg.title,
              subTitle: msg.subTitle,
              type: "success",
            });
            $("#moveUserDataModal").modal("hide");
            refreshTables();
          },
          spinner: "#moveUserDataBtn",
        });
      });
  });

  $(document).on("click", "#usersTable .move-user-team-btn", (e) => {
    const email = $(e.currentTarget).attr("data-email");
    const data = { userId: $(e.currentTarget).attr("data-userId") };

    wrappedGet({
      url: "/api/organizations/get",
      data: { organizationId: getUser().organizationId },
      success: (res) => {
        const selector = $("#moveUserTeamSelect");

        selector.find("option").remove();

        res.organization.teams.forEach((team) => {
          if (team.teamId !== getUser().teamId) {
            selector.append(
              $("<option>", {
                value: team.teamId,
                "data-content": `<i class="fa-fw far fa-users mr-2"></i>${team.teamName}`,
              }),
            );
          }
        });

        selector.selectpicker("refresh");

        $("#moveUserTeamEmail").text(email);

        resetMoveUserModal(true);
        $("#moveUserTeamModal").modal("show");

        $("#moveUserTeamBtn")
          .off("click")
          .click(() => {
            resetMoveUserModal(false);
          });

        $("#moveUserTeamBtnConfirm")
          .off("click")
          .click(() => {
            data.newTeamId = selector.selectpicker("val");
            wrappedPost({
              url: "/api/admin/modify",
              data: JSON.stringify({ kind: "move-user-team", data }),
              success: () => {
                showToast({
                  title: "User successfully moved",
                  subtitle: "This may take a few minutes",
                  type: "success",
                });
                refreshTables();
                $("#moveUserTeamModal").modal("hide");
              },
            });
          });
        $("#moveUserTeamBtnCancel")
          .off("click")
          .click(() => {
            $("#moveUserTeamModal").modal("hide");
          });
      },
    });
  });

  $("#addSeatsBtn").click(() => {
    const data = {
      additions: {
        nSeats: $("#addUserSeatsInput").val(),
        nAliasSeats: $("#addAliasSeatsInput").val(),
        nViewerSeats: $("#addViewerSeatsInput").val(),
      },
    };

    // If no seats are added then treat as not clicked
    // will ensure abandoned event is sent if user exits the modal manually
    if (Object.values(data.additions).some((v) => v && Number(v) > 0)) {
      isAddSeatsBtnClicked = true;
    }

    wrappedPost({
      url: "/api/admin/modify",
      data: JSON.stringify({ kind: "add-seats", data }),
      success: () => {
        showToast({ title: "Seats added", type: "success" });
        refreshTables();
        $("#addSeatsModal").modal("hide");
      },
      spinner: "#addSeatsBtn",
    });
  });

  $("#addSeatsModal").on("shown.bs.modal", () => {
    isAddSeatsBtnClicked = false;
  });

  $("#addSeatsModal").on("hidden.bs.modal", () => {
    if (!isAddSeatsBtnClicked) {
      wrappedPost({
        url: "/api/admin/add_seats_abandoned",
      });
    }
  });

  $("#apiKey").click((e) => e.target.select());

  $("#createAPIKeyBtn").click(() => {
    wrappedPost({
      url: "/api/admin/create",
      data: JSON.stringify({ kind: "apiKey" }),
      success: (res) => {
        $("#apiKey").val(res.apiKey);
        $("#deleteAPIKeyBtn").show();
        showToast({ title: "API Key created", type: "success" });
      },
      spinner: "#createAPIKeyBtn",
    });
  });

  $("#deleteAPIKeyBtn").click(() => {
    wrappedPost({
      url: "/api/admin/delete",
      data: JSON.stringify({ kind: "apiKey" }),
      success: () => {
        $("#apiKey").val("");
        $("#deleteAPIKeyBtn").hide();
        showToast({ title: "API Key deleted", type: "success" });
      },
      spinner: "#deleteAPIKeyBtn",
    });
  });

  $("#addCustomDomainBtn").click(() => {
    $("#addCustomDomainBtn").tooltip("dispose");

    wrappedPost({
      url: "/api/admin/create",
      data: JSON.stringify({
        kind: "team-domain",
        data: { domain: $("#customDomainInput").val() },
      }),
      success: () => {
        showToast({
          title: "Custom domain is being created",
          subtitle: "This may take a couple of minutes",
          type: "success",
        });
        checkCustomDomain();
      },
      spinner: "#addCustomDomainBtn",
    });
  });

  $("#deleteCustomDomainBtn").click(() => {
    wrappedPost({
      url: "/api/admin/delete",
      data: JSON.stringify({ kind: "team-domain" }),
      success: () => {
        checkCustomDomain();
      },
      spinner: "#deleteCustomDomainBtn",
    });
  });

  $("#domainSendLimit").change((e) => {
    $("#domainSendLimitForm").toggle(e.target.checked);
  });

  ["cs", "bd"].forEach((key) => {
    $(`#${key}DomainSendLimitInput`).on("input", (e) => {
      $(`#${key}DomainSendLimitOutput`).val($(e.target).val());
    });

    $(`#${key}DomainSendLimitInput`).change((e) => {
      $(`#${key}DomainSendLimitOutput`).val($(e.target).val());
    });
  });

  $("#saveDomainSendLimit").click(() => {
    const domainSendLimit = {};

    if ($("#domainSendLimit").prop("checked")) {
      if ($("#csDomainSendLimitInput").is(":visible")) {
        domainSendLimit.candidateSourcing = $("#csDomainSendLimitInput").val();
      }

      if ($("#bdDomainSendLimitInput").is(":visible")) {
        domainSendLimit.businessDevelopment = $(
          "#bdDomainSendLimitInput",
        ).val();
      }

      const domainExcluded = $("#domainExclusionTextArea")
        .val()
        .replaceAll("\n", " ")
        .replaceAll(",", " ")
        .split(" ")
        .filter((x) => x.length);
      const domainExcludedSet = new Set(domainExcluded);
      domainSendLimit.excluded = [...domainExcludedSet];
    }

    wrappedPost({
      url: "/api/admin/modify",
      data: JSON.stringify({ kind: "team", data: { domainSendLimit } }),
      success: () => {
        showToast({ title: "Changes saved", type: "success" });
      },
      error: () => {
        showToast({
          title: "Unable to save Domain Sending Limit settings",
          subtitle: "Please try again or contact support if the issue persists",
          type: "danger",
        });
      },
      spinner: `#saveDomainSendLimit`,
    });
  });

  addWebsocketListener((data) => {
    if (data.kind === "customDomainDeleted") checkCustomDomain();
    if (["customDomainCreated", "customDomainUpdated"].includes(data.kind)) {
      displayCustomDomainSettings(data.domain);
    }

    if (data.kind === "teamGroupDeleted") refreshTables();
  });

  $("#toggleChartTypeButton").click((e) => {
    chartType = chartType === "bar" ? "donut" : "bar";
    updateCharts(CREDITS_DATA);
    $(e.currentTarget).find("i").toggle();
  });

  if (!window.location.pathname.includes("/deliverability/report"))
    updateCreditUsageStats();

  $(".datepicker input").on("apply.daterangepicker", () =>
    updateCreditUsageStats(),
  );

  $("#downloadCreditUsageButton").click(() => downloadCreditUsage());

  ["azure", "google", "onelogin", "okta"].forEach((val) => {
    const uploadType = ["okta"].includes(val) ? "url" : "file";
    const uploadHTML =
      uploadType === "url"
        ? `<input type="text" class="form-control w-50" id="${val}XMLURL" placeholder="Enter XML URL">`
        : /* html */ `
          <form class="w-50">
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="${val}XMLFile" accept="text/xml">
              <label class="custom-file-label" for="${val}XMLFile">Upload XML File</label>
            </div>
          </form>`;

    $(`#${val}-tab .form-container`).html(/* html */ `
        ${uploadHTML}
        <p class="mt-4 mb-3">Or enter your details manually:</p>
        <div class="input-group mb-2 w-50">
          <div class="input-group-prepend">
            <span class="input-group-text">Entity ID</span>
          </div>
          <input type="text" class="form-control" id="${val}EntityID" placeholder="Enter your Entity ID">
        </div>
        <div class="input-group mb-2 w-50">
          <div class="input-group-prepend">
            <span class="input-group-text">Sign-on URL</span>
          </div>
          <input type="text" class="form-control" id="${val}URL" placeholder="Enter your single sign-on URL">
        </div>
        <form>
          <div class="custom-file w-50">
            <input type="file" class="custom-file-input" id="${val}CertificateFile">
            <label class="custom-file-label" for="${val}CertificateFile">Upload x509 Certificate</label>
          </div>
        </form>
      `);

    $(`#${val}-tab .button-container`).html(/* html */ `
        <button class="btn btn-primary" id="${val}SaveButton" type="button"><i class="fa-regular fa-save mr-2"></i>Save</button>
      `);

    $(`#${val}XMLFile, #${val}CertificateFile`).on("change", (e) => {
      const fileName = String($(e.currentTarget).val());
      $(e.currentTarget).siblings(".custom-file-label").html(fileName);
    });

    $(`#${val}SaveButton`).on("click", () => {
      const saveSAMLSettings = (xmlData, xmlUrl, x509Data) => {
        const data = {
          entity_id: $(`#${val}EntityID`).val(),
          sign_on_url: $(`#${val}URL`).val(),
          xmlData,
          xmlUrl,
          x509_certificate: x509Data,
        };

        wrappedPost({
          url: "/api/admin/create",
          data: JSON.stringify({ kind: "saml", data }),
          success: () => {
            showToast({
              title: "SAML settings saved successfully",
              type: "success",
            });
          },
          error: () => {
            showToast({
              title: "Unable to save SAML settings",
              subtitle:
                "Please try again or contact support if the issue persists",
              type: "danger",
            });
          },
          spinner: `#${val}SaveButton`,
        });
      };

      const manual =
        $(`#${val}EntityID`).val().length || $(`#${val}URL`).val().length;

      const XMLFile = document.querySelector(`#${val}XMLFile`)?.files[0];
      const XMLUrl = $(`#${val}XMLURL`).val();
      const x509File = document.querySelector(`#${val}CertificateFile`)
        ?.files[0];

      if (XMLFile) {
        const reader = new FileReader();
        reader.readAsText(XMLFile);
        reader.addEventListener("load", (e) =>
          saveSAMLSettings(e.currentTarget.result, ""),
        );
      } else if (XMLUrl) {
        saveSAMLSettings("", $(`#${val}XMLURL`).val());
      } else if (manual && x509File) {
        const reader = new FileReader();
        reader.readAsDataURL(x509File);
        reader.addEventListener("load", (e) =>
          saveSAMLSettings("", "", e.currentTarget.result),
        );
      } else {
        const uploadTypeStr = uploadType === "url" ? "URL" : "file";
        showToast({
          title: `Please include a valid XML ${uploadTypeStr} or enter your details manually`,
          type: "warning",
        });
      }
    });
  });

  $("#notInterestedReasonsTable").on(
    "click",
    ".remove-not-interested-reason",
    (e) => {
      const notInterestedReason = $(e.target).closest(".not-interested-reason");
      notInterestedReason.remove();
      setNotInterestedButtonVisibility();
    },
  );

  $("#add-not-interested-reason").click(() => {
    $("#notInterestedReasonsTable tbody").append(addInterestedReason());
    setNotInterestedButtonVisibility();
  });

  $("#saveNotInterestedReasons").click(() => {
    addSpinner("#saveNotInterestedReasons");

    const data = [];

    $("#notInterestedReasonsTable tbody .not-interested-reason").each(
      (_, el) => {
        const tagId = $(el).data("id");
        const title = $(el).find(".tag input").val();
        const description = $(el).find(".description input").val();

        if (title && description)
          data.push({
            tagId,
            title,
            description,
          });
      },
    );

    wrappedPost({
      url: "/api/not_interested/modify",
      data: JSON.stringify({ data }),
      success: () => {
        removeSpinner("#saveNotInterestedReasons");
        showToast({ title: "Changes saved", type: "success" });
      },
      error: () => {
        showToast({
          title: "Unable to save not interested reasons",
          subtitle:
            "Please try again or contact support if the issue persists.",
          type: "danger",
        });
        removeSpinner("#saveNotInterestedReasons");
      },
    });
  });

  $("#complianceCountrySelect").change((e) => {
    // Country-specific configuration mapping
    const COMPLIANCE_CONFIG = {
      AU: { taxIdText: "Company Number from ASIC" },
      AE: { taxIdText: "Company Registration Number" },
      CA: {
        taxIdText: "Business Number",
        taxIdTooltip:
          "Your Business Number (BN) is a 9 digit number provided by the Canada Revenue Agency (CRA)",
        taxIdPlaceholder:
          "Enter the first 9 digits of your Business Number (BN) only",
      },
      DE: { taxIdText: "Company Registration Number" },
      DK: { taxIdText: "CVR Number" },
      IE: { taxIdText: "Company Registration Number" },
      GB: {
        taxIdText: "Company Number",
        taxIdTooltip:
          "The company registration number should be the unique eight-character code assigned to your business",
      },
      NL: { taxIdText: "KVK Number" },
      US: {
        taxIdText: "EIN",
        taxIdTooltip:
          "Please ensure that the EIN is a 9 digit number in the format XX-XXXXXXX",
        postcodeText: "Zip Code",
        showPostcodeTooltip: true,
      },
    };

    const val = $(e.target).selectpicker("val");
    const config = COMPLIANCE_CONFIG[val] || {};

    $("#complianceCountrySpecificDiv").show();
    $("#complianceBusinessTypeDiv").toggle(config.hideBusinessType !== true);

    COMPLIANCE_COUNTRIES.forEach((code) => {
      $(`#compliance${code}StateDiv`).toggle(val === code);
    });

    $("#compliancePostcodeText").html(config.postcodeText || "Postcode");
    $("#compliancePostcodeTooltip").toggle(config.showPostcodeTooltip === true);
    $("#complianceTaxIdTooltip").attr(
      "data-original-title",
      config.taxIdTooltip || "",
    );
    $("#complianceTaxIdTooltip").toggle(config.taxIdTooltip !== undefined);
    $("#complianceTaxIdInput").attr(
      "placeholder",
      config.taxIdPlaceholder || "",
    );
    $("#complianceTaxIdText").html(config.taxIdText || "Tax ID");

    $("#complianceKycDiv").toggle(showCompliances.kyc && val !== "GB");
  });

  $("#complianceAdditionalCountriesSelect").on("change", () => {
    const selectedCountries =
      $("#complianceAdditionalCountriesSelect").selectpicker("val") || [];

    DIALLER_COUNTRIES.forEach((cc) => {
      $(`#compliance${capitalize(cc)}Div`).toggle(
        selectedCountries.includes(cc.toUpperCase()),
      );
    });
  });

  $("#additionalCountriesRegisterSelect").on("change", () => {
    const selectedCountries =
      $("#additionalCountriesRegisterSelect").selectpicker("val") || [];

    DIALLER_COUNTRIES.forEach((cc) => {
      $(`#${cc}RegisterDiv`).toggle(
        selectedCountries.includes(cc.toUpperCase()),
      );
    });
  });

  DIALLER_COUNTRIES.forEach((cc) => {
    $(`#${cc}ExpandBtn`).on("click", () => {
      $(`#${cc}RegisterForm`).toggle();
      $(`#${cc}ExpandBtn`).toggleClass("fa-chevron-down fa-chevron-up");
    });
  });

  ["complianceKyc", "kyc"].forEach((key) => {
    $(`#${key}RegistrationAuthoritySelect`).change((e) => {
      const val = $(e.target).selectpicker("val");
      $(`#${key}ExcerptDiv`).toggle(val !== "UK:CRN");
    });
  });

  ["kyc", ...DIALLER_COUNTRIES].forEach((cc) => {
    [`compliance${capitalize(cc)}`, cc].forEach((key) => {
      SUPPORTING_DOCS.forEach((doc) => {
        $(`#${key}${doc}FileInput`).on("change", (e) => {
          const fileReader = new FileReader();
          const file = e.target.files[0];

          fileReader.onloadend = () => {
            supportingDocs[`${cc}${doc}`] = fileReader.result;
          };
          fileReader.readAsDataURL(file);

          $(`#${key}${doc}Input`).val(file.name);
        });
      });
    });
  });

  $("#complianceOptInCheck").change((e) =>
    $("#complianceRegisterBtn").prop("disabled", !$(e.target).prop("checked")),
  );

  $("#complianceRegisterBtn").click(() => {
    const data = {
      country: $("#complianceCountrySelect").selectpicker("val"),
      streetAddress: $("#complianceStreetAddressInput").val(),
      city: $("#complianceCityInput").val(),
      state: $("#complianceStateDiv .selectpicker:visible").selectpicker("val"),
      postcode: $("#compliancePostcodeInput").val(),
      firstName: $("#complianceContactFirstNameInput").val(),
      lastName: $("#complianceContactLastNameInput").val(),
      email: $("#complianceContactEmailInput").val(),
      phone: $("#complianceContactPhoneInput").val(),
      taxId: $("#complianceTaxIdInput").val(),
      legalName: $("#complianceLegalNameInput").val(),
      businessType: $("#complianceBusinessTypeSelect").selectpicker("val"),
      industry: $("#complianceIndustrySelect").selectpicker("val"),
      supportEmail: $("#complianceSupportEmailInput").val(),
      website: $("#complianceWebsiteInput").val(),
    };

    const selectedCountries =
      $("#complianceAdditionalCountriesSelect").selectpicker("val") || [];
    ["kyc", ...DIALLER_COUNTRIES].forEach((cc) => {
      if (!["KYC", ...selectedCountries].includes(cc.toUpperCase())) return;
      data[cc] = ccComplianceFields(cc);
    });

    const emptyFields = $(
      "#complianceRegisterDiv input[required]:visible, #complianceRegisterDiv select[required]:visible",
    )
      .filter((_, element) => !$(element).val())
      .map((_, element) => element.id)
      .get();

    if (emptyFields.length > 0) {
      showToast({
        title: "Please fill in all required fields",
        type: "warning",
      });
      return;
    }

    addSpinner("#complianceRegisterBtn");

    const expandedData = {
      data,
      optIn: $("#complianceOptInCheck").prop("checked"),
      registerProfile: true,
      registerSms:
        showCompliances.sms && $("#complianceRegisterSmsCheck").prop("checked"),
      registerKyc: showCompliances.kyc || data.country === "GB",
    };

    DIALLER_COUNTRIES.forEach((cc) => {
      expandedData[`register${capitalize(cc)}`] =
        showCompliances[cc] && selectedCountries.includes(cc.toUpperCase());
    });

    wrappedPost({
      url: "/api/admin/register_twilio",
      data: JSON.stringify(expandedData),
      success: () => {
        removeSpinner("#complianceRegisterBtn");
        $("#complianceRegisterDiv").hide();
        Object.entries(showCompliances).forEach(([key, val]) =>
          $(`#${key}PendingDiv`).toggle(val),
        );
      },
      error: (err) => {
        removeSpinner("#complianceRegisterBtn");
        if (err.status === 400) {
          showToast({
            title: "An error occurred",
            subtitle: `${err.responseJSON}<br><br>Please contact customer support if this persists`,
            type: "danger",
          });
        } else {
          showToast({
            title: "An error occurred",
            subtitle: "Please contact customer support if this persists",
            type: "danger",
          });
        }
      },
    });
  });

  const registerFn = (prefix, data) => {
    const emptyFields = $(
      `#${prefix}RegisterDiv input[required]:visible, #${prefix}RegisterDiv select[required]:visible`,
    )
      .filter((_, element) => !$(element).val())
      .map((_, element) => element.id)
      .get();

    if (emptyFields.length > 0) {
      showToast({
        title: "Please fill in all required fields",
        type: "warning",
      });
      return;
    }

    addSpinner(`#${prefix}RegisterButton`);

    wrappedPost({
      url: "/api/admin/register_twilio",
      data: JSON.stringify(data),
      success: () => {
        removeSpinner(`#${prefix}RegisterButton`);
        $(`#${prefix}RegisterDiv`).hide();
        $(`#${prefix}PendingDiv`).show();
      },
      error: (err) => {
        removeSpinner(`#${prefix}RegisterButton`);
        if (err.status === 400) {
          showToast({
            title: "An error occurred",
            subtitle: `${err.responseJSON}<br><br>Please contact customer support if this persists`,
            type: "danger",
          });
        } else {
          showToast({
            title: "An error occurred",
            subtitle: "Please contact customer support if this persists",
            type: "danger",
          });
        }
      },
    });
  };

  ["sms", "kyc", ...DIALLER_COUNTRIES].forEach((cc) => {
    $(`#${cc}RegisterBtn`).on("click", () => {
      const data = {
        data: {},
        registerProfile: false,
        [`register${capitalize(cc)}`]: true,
      };
      data.data[cc] = ccComplianceFields(cc, true);
      registerFn(cc, data);
    });
  });

  $(document).on("change", "#automateReplyTags", () => {
    if ($("#automateReplyTags").is(":checked")) {
      $("#notInterestedReasonsCard").show();
    } else {
      $("#notInterestedReasonsCard").hide();
    }
  });

  wrappedGet({
    url: "/api/not_interested/get_all",
    success: (res) => {
      const standardReasons = res.reserved.map((reason) => {
        const firstChar = reason.title.slice(0, 1);
        const upperFirstChar = firstChar.toUpperCase();
        return upperFirstChar.concat(reason.title.slice(1));
      });

      $("#standardReasonsTooltip").attr(
        "data-original-title",
        standardReasons.join(", "),
      );
      res.custom.forEach((reason) => {
        addInterestedReason(
          reason.notInterestedTagId,
          reason.title,
          reason.description,
        );
      });
      if (res.custom.length <= 10) {
        addInterestedReason();
      }
    },
  });

  $("#moveUserDataToSelect").change((e) => {
    const val = $(e.currentTarget).selectpicker("val");
    $("#newEmailAddressInputWrapper").toggle(val === "newUser");
  });

  $("#activityFeedDropdown").on("change", (e) => {
    const selectedValue = $(e.target).val();
    $(".activity-feed-option").addClass("hidden");
    $(`#${selectedValue}Div`).removeClass("hidden");
  });

  $("#activityFeedSaveBtn").click(() => {
    const dropdownValue = $("#activityFeedDropdown").val();
    if (dropdownValue === "restrictActivityFeed") {
      modifyTeam({ key: "restrictActivityFeed", val: true });
    } else if (dropdownValue === "restrictSpecificDomains") {
      let restrictDomains = [];

      restrictDomains = $("#restrictDomainsInput")
        .tokenfield("getTokens")
        .map((x) => x.value);

      if (restrictDomains.length === 0) {
        backdropAlert(
          `Restrict Specific Domains list cannot be empty. If you don't want to restrict your activity feed, then choose "Unrestricted" instead.`,
        );
        return;
      }
      saveActivityFeedSettings({ restrictDomains });
    } else if (dropdownValue === "restrictNone") {
      saveActivityFeedSettings({ restrictDomains: [] });
    }
  });

  $("#v-pills-saml-tab").toggle(!!getUser().showSamlSetup);

  if (USER.hasUsedDialler && (!teamHasDialler() || USER.isDiallerTrial))
    $("#purchaseDialerCard").toggleClass("d-none d-flex");

  $("#openDiallerPlanModalBtn").on("click", () => {
    $("#buyDiallerPlanBtn").prop("disabled", true);
    $(".buyDiallerAgreementCheckbox").prop("checked", false);
    $("#buyDiallerPlanModal").modal("show");
    $("#buyDiallerAgreementDiv").hide();

    $("#buyDiallerRegionsSelector, #buyDiallerPlanSelector").on(
      "change",
      () => {
        $(".buyDiallerAgreementCheckbox").prop("checked", false);
        $("#buyDiallerPlanBtn").prop("disabled", true);
        const regions = $("#buyDiallerRegionsSelector").val();
        const plan = $("#buyDiallerPlanSelector").val();
        $("#buyDiallerTerms").empty();
        if (regions && plan) {
          wrappedGet({
            url: "/api/admin/get_feature_pricing",
            data: { feature: "dialler", plan, regions },
            success: (res) => {
              const symbol = { usd: "$", gbp: "£", eur: "€" }[res.currency];
              const price = `${symbol}${res.price}`;

              const terms = `
                <strong>Thanks for choosing this plan!</strong><br /><br />
                The cost per user seat for this plan is ${price} per month. <br /><br />
                This will be billed on the same frequency as your existing SourceWhale subscription,
                and we will immediately invoice you the pro-rated fees to cover the remainder of your current billing period.
                Calls outside of the ${regionsToText(
                  regions,
                )} are not included in your plan, and are billed monthly in arrears on a pay-as-you-go basis - see <a href="https://assets.cdn.prod.twilio.com/pricing-csv/OutboundVoicePricing.csv">here</a> for international call pricing. <br /><br />
                Your dialer plan will automatically renew with your SourceWhale contract for the contract term (at the same minutes, countries and other options) unless you give notice to terminate it before the automatic renewal (see your SourceWhale contract for the period of notice required). <br /><br />
                By adding this dialer plan you are accepting our <a href="https://sourcewhale.notion.site/Fair-Usage-Search-Credits-Dialer-and-SMS-105c223e19f14bfe90a65605ba5482c8">fair use policy</a> and confirming that you have authorization to agree to the above on behalf of your organization`;

              $(".buyDiallerTerms").html(terms);
              $("#buyDiallerAgreementDiv").show();
            },
          });
        }
      },
    );

    $(".buyDiallerAgreementCheckbox").on("change", () => {
      const regions = $("#buyDiallerRegionsSelector").val();
      const plan = $("#buyDiallerPlanSelector").val();
      const agreed = $(".buyDiallerAgreementCheckbox").prop("checked");
      $("#buyDiallerPlanBtn").prop("disabled", !(regions && plan && agreed));
    });

    $("#buyDiallerPlanBtn")
      .off("click")
      .on("click", () => {
        const regions = $("#buyDiallerRegionsSelector").val();
        const plan = $("#buyDiallerPlanSelector").val();
        const agreed = $(".buyDiallerAgreementCheckbox").prop("checked");
        wrappedPost({
          url: "/api/admin/modify",
          data: JSON.stringify({
            kind: "add-feature",
            data: { feature: "dialler", plan, regions, agreedTerms: agreed },
          }),
          success: () => {
            showToast({
              title: "Dialer successfully purchased!",
              type: "success",
            });
            $("#buyDiallerPlanModal").modal("hide");
            $("#purchaseDialerCard").toggleClass("d-flex d-none");
          },
          spinner: "#buyDiallerPlanBtn",
        });
      });
  });

  refreshTables();
  synchronizeNavStateAndHash();
};
